import {
  AdminDatePickerInputModal,
  AdminRadioInput,
  Button,
  Div,
  ErrorToast,
  H5,
  Modal,
  PropsModal,
  Separator,
  dateTimeInitial,
  daysOfWeekFrom1,
  format24hToDate,
  formatDateToTime24h,
} from '@vgrubs/components';
import { ScheduleEntity } from 'components/src/types/location.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const AddEditFundingTip = ({
  modalIsOpen,
  closeModal,
  edit,
  setFundedTipSchedule,
}: PropsModal & {
  modalIsOpen: ScheduleEntity | null | boolean;
  setFundedTipSchedule: Dispatch<SetStateAction<ScheduleEntity[]>>;
  edit?: boolean;
}) => {
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState(0);

  const [timeFrom, setTimeFrom] = useState<Date[]>([dateTimeInitial]);
  const [timeTo, setTimeTo] = useState<Date[]>([dateTimeInitial]);

  const data =
    typeof modalIsOpen === 'boolean' ? null : (modalIsOpen as ScheduleEntity);

  const toggleDaySelection = (day) => {
    setSelectedDayOfWeek(day);
  };

  const handleFinishAction = () => {
    setSelectedDayOfWeek(0);
    setTimeFrom([dateTimeInitial]);
    setTimeTo([dateTimeInitial]);
    closeModal?.();
  };

  useEffect(() => {
    if (edit && data) {
      setSelectedDayOfWeek(data.dayOfTheWeek ?? 0);
      setTimeFrom([format24hToDate(data.startTime)]);
      setTimeTo([format24hToDate(data.endTime)]);
    } else {
      setSelectedDayOfWeek(0);
      setTimeFrom([dateTimeInitial]);
      setTimeTo([dateTimeInitial]);
    }
  }, [modalIsOpen]);

  const handleSubmit = () => {
    if (selectedDayOfWeek === 0 || !timeFrom || !timeTo)
      return ErrorToast('Please fill in all information');

    if (timeFrom[0] >= timeTo[0]) {
      return ErrorToast('From time must be before to time');
    }

    if (edit) {
      setFundedTipSchedule((prev) => {
        return prev.map((item, i) => {
          if (i === data?.index) {
            return {
              amount: item.amount,
              dayOfTheWeek: selectedDayOfWeek,
              startTime: formatDateToTime24h(timeFrom[0]),
              endTime: formatDateToTime24h(timeTo[0]),
            };
          } else return item;
        });
      });
    } else {
      setFundedTipSchedule((prev) => [
        ...prev,
        {
          amount: prev[0].amount,
          dayOfTheWeek: selectedDayOfWeek,
          startTime: formatDateToTime24h(timeFrom[0]) || '',
          endTime: formatDateToTime24h(timeTo[0]) || '',
        },
      ]);
    }

    handleFinishAction();
  };

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header={`${edit ? 'Edit' : 'Add'} Tip Funding`}
      textAlign="left"
      width="500px"
    >
      <>
        <Separator />
        {daysOfWeekFrom1.map(({ name, value }) => (
          <div key={value}>
            <AdminRadioInput
              label={name}
              checked={selectedDayOfWeek === value}
              onClick={() => toggleDaySelection(value)}
            />
            <Separator />
          </div>
        ))}
        <H5 $mt="32" $mb="16" $center>
          Select Hours From - To
        </H5>
        <Div $flex $gap="24px">
          <AdminDatePickerInputModal
            format="hh:mm a"
            options={{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              noCalendar: true,
            }}
            placeholder="From"
            $textCenter
            onChange={setTimeFrom}
            value={timeFrom}
          />
          <AdminDatePickerInputModal
            format="hh:mm a"
            options={{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              noCalendar: true,
            }}
            placeholder="To"
            $textCenter
            onChange={setTimeTo}
            value={timeTo}
          />
        </Div>
      </>

      <Button $selected $w="100%" $mt="32" onClick={handleSubmit}>
        Confirm
      </Button>
      <Button $selected $gray $w="100%" $mt="16" onClick={handleFinishAction}>
        Cancel
      </Button>
    </Modal>
  );
};
